export const kebabToCapitalized = (s: string) => {
  if (!s) return s

  return `${s[0].toUpperCase()}${s.substring(1).replace(/-/g, ' ')}`
}

export const prettifyCredentialType = (name: string) => {
  return kebabToCapitalized(name).replace(/[Aa]pi/g, 'API')
}
